<template lang="pug">
.order-comments
  v-container
    v-row(justify-center, style="overflow: hidden")
      v-col
        h2.primary--text {{$t('Comment.name')}}
  g-comments-timeline(v-model="comment", v-bind="{ comments, loading }", @post="postComment")
</template>

<script>
import axios from 'axios';

export default {
  props: {
    comments: {
      type: Array,
      default: () => ([]),
    },
    orderId: null,
    orderBusinessScopeId: null,
  },
  data: () => ({
    loading: false,
    comment: null,
  }),
  methods: {
    async load () {
      this.comments = (await axios.get(`comment?load[]=User`, { params: { withoutGlobalBusinessScope: true, where: [`x => x.orderId == ${this.orderId}`] }})).data.data;
    },
    async postComment() {
      try {
        this.loading = true;
        const c = { orderId: this.orderId, commentText: this.comment, businessScopeId: this.orderBusinessScopeId };
        await axios.post(`Comment`, c);

        this.comment = null;
        this.comments = (await axios.get(`comment?load[]=User`, { params: { withoutGlobalBusinessScope: true, where: [`x => x.orderId == ${this.orderId}`] }})).data.data;
      } catch(e) {
        console.log('ERROR POST ', this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.load();
  },
}
</script>
